import imageHotspot from "./image-hotspot";

export default {
  "image-hotspot": imageHotspot,
};
